/* USPE quote list: browser-stored RFQ list, product "Add to Quote", quote request form
   (native Shopify contact form) and Klaviyo "Requested Quote" event. */
(function () {
  if (window.USPEQuote) return;
  var KEY = 'uspe_quote_v1';
  var read = function () { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } };
  var write = function (items) {
    try { localStorage.setItem(KEY, JSON.stringify(items)); } catch (e) {}
    document.dispatchEvent(new CustomEvent('uspe:quote:change', { detail: { items: items } }));
  };
  var count = function () { return read().reduce(function (n, i) { return n + (parseInt(i.qty, 10) || 0); }, 0); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };

  var kOf = function (i) { return String(i.key || i.variantId); };
  var api = {
    items: read,
    count: count,
    add: function (item) {
      var items = read();
      item.key = item.key || String(item.variantId) + (item.addons && item.addons.length ? '|' + item.addons.join('|') : '');
      var found = items.find(function (i) { return kOf(i) === item.key; });
      if (found) found.qty = (parseInt(found.qty, 10) || 0) + (parseInt(item.qty, 10) || 1);
      else items.push(Object.assign({ qty: 1, notes: '' }, item));
      write(items);
    },
    update: function (variantId, patch) {
      var items = read();
      items.forEach(function (i) { if (kOf(i) === String(variantId)) Object.assign(i, patch); });
      write(items.filter(function (i) { return (parseInt(i.qty, 10) || 0) > 0; }));
    },
    remove: function (variantId) { write(read().filter(function (i) { return kOf(i) !== String(variantId); })); },
    clear: function () { write([]); },
    summary: function () {
      return read().map(function (i, n) {
        return (n + 1) + '. ' + i.title + (i.variantTitle && i.variantTitle !== 'Default Title' ? ' (' + i.variantTitle + ')' : '') +
          (i.sku ? ' [' + i.sku + ']' : '') + ' x ' + i.qty + (i.addons && i.addons.length ? ' | Options: ' + i.addons.join('; ') : '') + (i.notes ? ' | Notes: ' + i.notes : '') + ' | ' + location.origin + i.url;
      }).join('\n');
    }
  };
  window.USPEQuote = api;

  /* Floating quote list button */
  function renderFab() {
    var n = count();
    var fab = document.querySelector('.uspe-quote-fab');
    var onQuotePage = !!document.querySelector('[data-uspe-quote-page]');
    if (!n || onQuotePage) { if (fab) fab.remove(); return; }
    if (!fab) {
      fab = document.createElement('a');
      fab.className = 'uspe-quote-fab';
      fab.href = '/pages/quote-request?view=quote-request';
      document.body.appendChild(fab);
    }
    fab.innerHTML = '<span>Quote list</span><b>' + n + '</b>';
    fab.setAttribute('aria-label', 'Quote list, ' + n + ' items');
    document.querySelectorAll('[data-uspe-count]').forEach(function (el) { el.textContent = n; });
  }

  /* Product page buy box */
  function initBox(box) {
    if (box.dataset.uspeReady) return; box.dataset.uspeReady = '1';
    var variants = [];
    try { variants = JSON.parse(box.querySelector('[data-uspe-variants]').textContent); } catch (e) {}
    var qtyInput = box.querySelector('[data-uspe-qty-input]');
    box.querySelectorAll('[data-uspe-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + parseInt(b.dataset.uspeQty, 10));
      });
    });
    var current = function () {
      var scope = box.closest('.product__info-container') || document;
      var picker = scope.querySelector('variant-selects, variant-radios') || document.querySelector('variant-selects, variant-radios');
      var chosen = [];
      if (picker) {
        picker.querySelectorAll('select').forEach(function (s) { chosen.push(s.value); });
        picker.querySelectorAll('fieldset').forEach(function (f) { var c = f.querySelector('input:checked'); if (c) chosen.push(c.value); });
      }
      var match = variants.find(function (v) { return chosen.length && v.options.every(function (o, i) { return o === chosen[i]; }); });
      if (!match) {
        var urlId = new URLSearchParams(location.search).get('variant');
        match = variants.find(function (v) { return String(v.id) === urlId; }) || variants[0];
      }
      return match || {};
    };
    var addons = function () { return Array.prototype.map.call(box.querySelectorAll('[data-uspe-opts] input:checked'), function (c) { return c.value; }); };
    var add = function () {
      var v = current();
      api.add({
        variantId: v.id, productId: box.dataset.productId, handle: box.dataset.handle,
        title: box.dataset.title, variantTitle: v.title, sku: v.sku || box.dataset.sku,
        url: box.dataset.url + (v.id ? '?variant=' + v.id : ''), image: box.dataset.image,
        qty: Math.max(1, parseInt(qtyInput.value, 10) || 1), addons: addons()
      });
      if (window.klaviyo && klaviyo.push) {
        try { klaviyo.push(['track', 'Added to Quote', { ProductName: box.dataset.title, Variant: v.title, SKU: v.sku, Options: addons(), URL: location.origin + box.dataset.url }]); } catch (e) {}
      }
    };
    box.querySelector('[data-uspe-add]').addEventListener('click', function () {
      add();
      var msg = box.querySelector('[data-uspe-added]'); msg.hidden = false;
      var btn = this; btn.classList.add('is-added'); btn.querySelector('span').textContent = 'Added to Quote';
      setTimeout(function () { btn.classList.remove('is-added'); btn.querySelector('span').textContent = 'Add to Quote'; }, 2200);
    });
    box.querySelector('[data-uspe-request-now]').addEventListener('click', function (e) {
      var v = current();
      var key = String(v.id) + (addons().length ? '|' + addons().join('|') : '');
      var exists = read().some(function (i) { return kOf(i) === key; });
      if (!exists) add();
    });
  }

  /* Quote request page */
  function initPage(root) {
    if (root.dataset.uspeReady) return; root.dataset.uspeReady = '1';
    var list = root.querySelector('[data-uspe-quote-list]');
    var empty = root.querySelector('[data-uspe-quote-empty]');
    var field = root.querySelector('[data-uspe-quote-field]');
    var form = root.querySelector('form[data-uspe-rfq-form]');
    if (root.dataset.posted === 'true' || /contact_posted=true/.test(location.search)) { api.clear(); }

    function render() {
      var items = read();
      if (empty) empty.hidden = items.length > 0;
      if (list) {
        list.innerHTML = items.map(function (i) {
          return '<li class="uspe-ql__item" data-id="' + esc(kOf(i)) + '">' +
            (i.image ? '<img src="' + esc(i.image) + '" alt="" width="72" height="72" loading="lazy">' : '<span class="uspe-ql__ph"></span>') +
            '<div class="uspe-ql__info"><a href="' + esc(i.url) + '">' + esc(i.title) + '</a>' +
            (i.variantTitle && i.variantTitle !== 'Default Title' ? '<span>' + esc(i.variantTitle) + '</span>' : '') +
            (i.sku ? '<span class="uspe-ql__sku">Model ' + esc(i.sku) + '</span>' : '') +
            (i.addons && i.addons.length ? '<ul class="uspe-ql__opts">' + i.addons.map(function (a) { return '<li>' + esc(a) + '</li>'; }).join('') + '</ul>' : '') +
            '<input class="uspe-ql__notes" type="text" maxlength="200" placeholder="Custom size, finish or utility notes (optional)" value="' + esc(i.notes || '') + '"></div>' +
            '<div class="uspe-ql__qty"><label>Qty<input type="number" min="0" value="' + esc(i.qty) + '"></label>' +
            '<button type="button" class="uspe-ql__remove">Remove</button></div></li>';
        }).join('');
      }
      if (field) field.value = api.summary();
    }
    if (list) {
      list.addEventListener('change', function (e) {
        var li = e.target.closest('.uspe-ql__item'); if (!li) return;
        if (e.target.matches('input[type=number]')) api.update(li.dataset.id, { qty: parseInt(e.target.value, 10) || 0 });
        if (e.target.matches('.uspe-ql__notes')) api.update(li.dataset.id, { notes: e.target.value });
      });
      list.addEventListener('click', function (e) {
        if (!e.target.matches('.uspe-ql__remove')) return;
        api.remove(e.target.closest('.uspe-ql__item').dataset.id);
      });
    }
    document.addEventListener('uspe:quote:change', render);
    render();
    if (form) bindForm(form);
  }

  /* Klaviyo profile + event for any USPE RFQ form, then native Shopify submit */
  function bindForm(form) {
    if (form.dataset.uspeBound) return; form.dataset.uspeBound = '1';
    form.addEventListener('submit', function (e) {
      if (form.dataset.uspeSent === '1') return;
      var field = form.querySelector('[data-uspe-quote-field]');
      if (field) field.value = api.summary() || field.value;
      var val = function (n) { var el = form.querySelector('[name="contact[' + n + ']"]'); return el ? el.value.trim() : ''; };
      var email = val('email');
      if (!email || !window.klaviyo) return;
      e.preventDefault();
      var name = val('name').split(' ');
      var items = read();
      var props = {
        Source: form.dataset.source || 'USPE RFQ',
        Organization: val('Organization'), OrganizationType: val('Organization type'),
        JobTitle: val('Title'), Phone: val('phone'), ShipTo: val('Ship to'), Timeline: val('Timeline'),
        Funding: val('Funding'), BrandEqual: val('Brand equal to'), Message: val('body'),
        ItemCount: items.length, ItemNames: items.map(function (i) { return i.title; }),
        Items: items.map(function (i) { return { ProductName: i.title, Variant: i.variantTitle, SKU: i.sku, Options: i.addons || [], Quantity: i.qty, Notes: i.notes, URL: location.origin + i.url, ImageURL: i.image }; }),
        PageURL: location.href
      };
      var done = false;
      var go = function () { if (done) return; done = true; form.dataset.uspeSent = '1'; if (form.requestSubmit) form.requestSubmit(); else form.submit(); };
      try {
        Promise.resolve(klaviyo.identify({ email: email, first_name: name.shift() || '', last_name: name.join(' '), organization: props.Organization, title: props.JobTitle }))
          .then(function () { return klaviyo.track('Requested Quote', props); })
          .then(go, go);
      } catch (err) { go(); }
      setTimeout(go, 2500);
    });
  }

  /* Cart guard: move quote-only items out of the cart and into the quote list */
  function guardCart() {
    var el = document.getElementById('uspe-cart-guard');
    if (!el || el.dataset.done) return; el.dataset.done = '1';
    var lines = []; try { lines = JSON.parse(el.textContent) || []; } catch (e) {}
    if (!lines.length) return;
    var updates = {};
    lines.forEach(function (l) {
      var exists = read().some(function (i) { return String(i.variantId) === String(l.variantId); });
      if (!exists) api.add({ variantId: l.variantId, productId: l.productId, handle: l.handle, title: l.title, variantTitle: l.variantTitle, sku: l.sku, url: l.url + '?variant=' + l.variantId, image: l.image, qty: l.qty });
      updates[l.key] = 0;
    });
    try { sessionStorage.setItem('uspe_moved', String(lines.length)); } catch (e) {}
    fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: updates }) })
      .then(function () { if (/^\/cart\/?$/.test(location.pathname)) location.replace('/pages/quote-request?view=quote-request&moved=1'); else location.reload(); })
      .catch(function () {});
  }
  function movedNotice() {
    var root = document.querySelector('[data-uspe-quote-page]'); if (!root) return;
    var n = 0; try { n = parseInt(sessionStorage.getItem('uspe_moved'), 10) || 0; sessionStorage.removeItem('uspe_moved'); } catch (e) {}
    if (!n && !/moved=1/.test(location.search)) return;
    var p = document.createElement('p'); p.className = 'uspe-moved-note'; p.setAttribute('role', 'status');
    p.textContent = 'Quote-only equipment is priced to your project, so ' + (n === 1 ? 'the item in your cart was' : 'the items in your cart were') + ' moved to your quote list. Add your details below to get a formal quote.';
    root.insertBefore(p, root.firstChild);
  }

  function init() {
    guardCart(); movedNotice();
    document.querySelectorAll('[data-uspe-quote-box]').forEach(initBox);
    document.querySelectorAll('[data-uspe-quote-page]').forEach(initPage);
    document.querySelectorAll('form[data-uspe-rfq-form]').forEach(bindForm);
    renderFab();
  }
  document.addEventListener('uspe:quote:change', renderFab);
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  new MutationObserver(function () { document.querySelectorAll('[data-uspe-quote-box]:not([data-uspe-ready])').forEach(initBox); })
    .observe(document.documentElement, { childList: true, subtree: true });
})();
